// navbar background color change on scroll
function navbarScroll() {
    const scroll = window.scrollY || document.documentElement.scrollTop
    const navbarOverlap = document.querySelector('.navbar-overlap');
    const navbarDark = document.querySelector('.navbar-dark');

    if (scroll < 10) {
        if (navbarOverlap) { navbarOverlap.classList.remove('dark-mode'); }
        if (navbarDark) { navbarDark.classList.remove('dark-mode'); }
    } else {
        if (navbarOverlap) { navbarOverlap.classList.add('dark-mode'); }
        if (navbarDark) { navbarDark.classList.add('dark-mode'); }
    }
}

// On window scroll
window.addEventListener('scroll', function() {
    navbarScroll();
});
navbarScroll();

// copy to clipboard
document.querySelectorAll(".btn-clipboard").forEach(button => {
    button.addEventListener('click', function(event) {
        navigator.clipboard.writeText(event.target.nextElementSibling.textContent)
        .then(() => { /* success */ })
        .catch(err => window.elmahio.error("Error during copy command", err));

        const text = event.target.innerText;
        event.target.innerText = "Copied!";
        event.target.disabled = true;
        event.target.classList.add('disabled');
        if (event.target.innerText = "Copied!") {
            setTimeout(() => {
                event.target.innerText = text;
                event.target.disabled = false;
                event.target.classList.remove('disabled');
            }, 1000);
        }
    });
});